import { createAsyncThunk } from '@reduxjs/toolkit';
import moment from 'moment';
import saveAs from 'file-saver';

import api from 'src/app/apiSingleton';

export const getAdminExportData = createAsyncThunk(
  'adminExport/get-admin-export-data',
  async (data, thunkApi) => {
    try {
      const response = await api.adminExport.getAdminExportData(data);

      return response;
    } catch (err) {
      console.warn(err);
      return thunkApi.rejectWithValue(err);
    }
  },
);

export const downloadAdminExportXlsx = createAsyncThunk(
  'adminExport/download-admin-export-xlsx',
  async (data, thunkApi) => {
    try {
      const { issuer_id, display_name } = data;

      const payload = {
        issuer_id,
      };

      const response = await api.adminExport.downloadAdminExportXlsx(payload);

      const date = moment().format('YYYY-MM-DD');

      const blob = await response.blob();
      const filename = `issuer-report-${display_name}-${date}.xlsx`;

      saveAs(blob, filename);
    } catch (err) {
      console.warn(err);
      return thunkApi.rejectWithValue(err);
    }
  },
);
